
import { ActivityControl } from '../../models/activity-control';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs/operators';
import { ActivityControlBuilder } from '../../models/builders/activity-control.builder';

const activityControlBody = (activityControl: ActivityControl) => ({
  description: activityControl.description,
  activityStartTxt: activityControl.activityStartTxt,
  subactivityHash: activityControl.subactivity,
  controlHash: activityControl.control
});

@Injectable()
export class ActivityControlApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }activity-controls`;
  }

  createActivityControl(activityControl) {
    return this.httpClient.post(this.apiUrl, activityControlBody(activityControl)).pipe(map(ActivityControlBuilder.fromJson));
  }

  deleteActivityControl(activityControl: ActivityControl) {
    return this.httpClient.delete(`${ this.apiUrl }/${ activityControl.hash }`);
  }

  getActivityControls() {
    return this.httpClient.get(`${ this.apiUrl }`).pipe(map(ActivityControlBuilder.fromList));
  }

  getActivityControl(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(ActivityControlBuilder.fromJson)
      );
  }

  updateActivityControl(activityControl: ActivityControl) {
    return this.httpClient.put(`${ this.apiUrl }/${ activityControl.hash }`, activityControlBody(activityControl));
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/activity-control-api.service.ts